import { inIframe } from '@iblai/ibl-web-react-common';
import { authGuard } from './auth';
import { BASE_API_URL } from '../api';
import { notifyParentOnLoad } from '../auth';

const urlParams = new URLSearchParams(window.location.search);

const getMentorPublicSettings = async (platformKey, mentorId) => {
  if (!mentorId || mentorId === 'undefined' || mentorId === 'explore') {
    return {};
  }
  let username = 'anonymous';
  const userDataStr = localStorage.getItem('userData');
  if (userDataStr) {
    const userData = JSON.parse(userDataStr);
    username = userData?.user_nicename;
  }
  const url = `${BASE_API_URL}/api/ai-mentor/orgs/${platformKey}/users/${username}/mentors/${mentorId}/public-settings/`;
  try {
    const response = await fetch(url);
    if (!response.ok) {
      if (response.status === 502) {
        window.location.assign('/');
      }
    }
    return await response.json();
  } catch (e) {}
};

export const loadPlatformData = (appData, setAppData) => {
  notifyParentOnLoad();
  const embed = urlParams.get('embed') === 'true';
  return async ({ request, params }) => {
    const mentorSettings = await getMentorPublicSettings(
      params.platform,
      params.mentor
    );
    let requireLogin = true;
    if (inIframe() && embed) {
      requireLogin = !Boolean(mentorSettings?.allow_anonymous);
    }
    await authGuard(false, requireLogin, appData, setAppData)();
    return {
      mentorSettings,
    };
  };
};
